export enum RoleTypeEnum {
    CLIENT = "B2B_CLIENT",
    ADMIN = "B2B_CLIENT_ADMIN",
    B2B = "B2B",
}

export enum RoleValueEnum {
    CLIENT = "CLIENT",
    ADMIN = "ADMIN"
}